import React from "react"
import game from "moonwalk.png"

const Moonwalk = props => <img src={game} className="game" {...props} />

export default Moonwalk
